const riot = require('riot');

riot.tag2('module-reminds', '<div class="s-full"> <div class="sticky t63 l0 f fr z1 bg-background_light_secondary pb8 s-t46" if="{!opts.hideTab}"> <div class="f fclm fb"> <div class="f fm mb16"> <div class="f fm py3 px16 border-right-not-last cursor-pointer {current === tab.id ? &quot;bold&quot;: &quot;&quot;}" each="{tab in tabs}" onclick="{selectTab}"><span>{tab.label}</span><span if="{tab.count()}">({tab.count()})</span></div> </div> <div class="f fm overflow-x-scroll scrollbar-none mb14"> <label class="f fr flex-fixed cursor-pointer mr16 tooltip" aria-label="@{app.store.currentUser.data.screen_name}を含むリマインドに絞り込む" data-tooltip-position="top"> <input class="checkbox mr4" ref="meMentionCheckbox" type="checkbox" onchange="{toggleMeMentionChecked}"> <div class="lh15 fs12 hover-trigger hover-text-primary">個人メンションのみ</div> </label> <label class="f fr flex-fixed cursor-pointer tooltip" aria-label="自分で追加したリマインドのみに絞り込む" data-tooltip-position="top"> <input class="checkbox mr4" type="checkbox" onchange="{toggleManualRemindChecked}"> <div class="lh15 fs12 hover-trigger hover-text-primary">手動登録のみ</div> </label> </div> <div class="f overflow-x-scroll container scrollbar-none py2"><i class="f fh icon-close-circle text-background_dark_primary px2 pb2 cursor-pointer fs24 hover-trigger hover-text-primary mr8 tooltip" if="{projectTag}" onclick="{resetProjectTag}" aria-label="絞り込み解除" data-tooltip-position="top"></i> <div class="relative flex-fixed cursor-pointer hover-trigger hover-opacity-80 mr8 mr0-last tooltip" each="{project in projects}" aria-label="{projectTag &amp;&amp; project.id === projectTag ? &quot;解除&quot; : &quot;絞り込み&quot;}" data-tooltip-position="top" onclick="{selectProjectTag}" role="button"> <div class="f fh h22 px8 rounded-4 border font-lato {project.id === projectTag ? &quot;&quot; : &quot;&quot;}" riot-style="background-color: {project.id === projectTag ? &quot;#FFFFFF&quot; : project.getColor()}; border-color: {project.id === projectTag ? project.getColor() : transparent}; color: {project.id === projectTag ? project.getColor() : &quot;#FFFFFF&quot;}"><i class="f fh icon-check px2 cursor-pointer fs18 mln5" if="{projectTag &amp;&amp; project.id === projectTag}"></i> <div class="bold fs12 lh13 word-break-all line-clamp-1">{project.data.name}</div> </div> </div> </div> </div> </div> <div class="pb16"> <div class="mb16" each="{items,label in getSectionedReminds()}"> <div class="f fm w-full py16" if="{getFilterItems(items).length}"> <div class="flex-fixed font-lato bold fs11 text-label_dark_medium word-break-keep mr16">{label}</div> <div class="h1 w-full rounded-1 bg-separator_opacity"></div> </div> <div class="mb16 mb0-last" each="{item in getFilterItems(items)}" data-is="item-remind" remind="{item}" onmouseenter="{onMouseEnterRemind}" onmouseleave="{onMouseLeaveRemind}"></div> </div> <div class="f fh" if="{!sclazy.isLoading &amp;&amp; !sclazy.items.length}"> <div>リマインドはありません</div> </div> <div class="f fh s-full" if="{sclazy.isLoading}"> <div data-is="atom-loading"></div> </div> </div> </div>', 'module-reminds,[data-is="module-reminds"]{display:block}', '', function(opts) {

    this.containMeMentionChecked = false;

    this.tabs = [
      {id: 'not_yet', label: '未リアクション', count: () => app.store.getWorkspaceUser().data.remind_count },
      {id: 'all', label: 'すべて'},
    ];
    this.current = this.tabs[0].id;
    this.projects = [];
    this.projectTag = null;

    this.on('mount', () => {
      app.shortcut.saveView();
      app.shortcut.setView('remind', { viewTag: this });

      if (spat.isBrowser) {
        this.projectTag = this.getProjectQuery();
      }

      this.sclazy = Sclazy({
        target: this.parent.refs.body,
        onload: async (data) => {
          this.sclazy.isLoading = true;
          this.update();
          let limit = 32;
          let items;
          if (this.current === 'all') {
            items = await this.fetchAllReminds({limit, sclazyData: data});
          }
          else {
            items = await this.fetchNotYetReminds({limit, sclazyData: data});
          }

          if (items.length) {
            this.projects.push(...this.getProjectTags(items));
            this.projects = app.utils.unique(this.projects, p => p.id);
          }

          data.addItems(items);
          this.sclazy.next(items.length !== 0);
          this.sclazy.isLoading = false;
          this.update();
        },
        onscrollend: () => {
          this.sclazy.load();
        },
      });
    });

    this.on('unmount', () => {
      app.shortcut.restoreView();
    });

    this.getProjectTags = (items) => {
      let projects = [];
      items.forEach(item => {
        let project = item.relation.project;

        if (project && !projects.some(p => p.id === project.id)) {
          projects.push(project);
        }

      });

      projects.sort((a, b) => {
        if (a.data.name < b.data.name) return -1;
        if (a.data.name > b.data.name) return 1;
        return 0;
      });
      return projects;
    };

    this.selectProjectTag = ({ item }) => {
      let { project } = item;
      let project_tag = this.getProjectQuery();

      if (project_tag === project.id) {
        this.resetProjectTag();
        return;
      }

      spat.router.replaceState(`${location.pathname}?project_tag=${encodeURIComponent(project.id)}`);
      this.projectTag = project.id;
    };

    this.getProjectQuery = () => {
      let url = new URL(location.href);
      let project_tag = url.searchParams.get('project_tag');
      return project_tag;
    };

    this.resetProjectTag = () => {
      this.projectTag = null;
      spat.router.replaceState(`${location.pathname}`);
    };

    this.fetchAllReminds = async ({limit, sclazyData}) => {
      let cursor = sclazyData.cursor ? sclazyData.cursor.doc : null;
      let data = {
        limit,
        cursor
      };
      let reminds = await app.store.workspace_user.fetchAllReminds(data);
      sclazyData.cursor = reminds.slice(-1)[0];
      return reminds;
    };

    this.fetchNotYetReminds = async ({limit, sclazyData}) => {
      let cursor = sclazyData.cursor ? sclazyData.cursor.doc : null;
      let data = {
        limit,
        cursor
      };
      let reminds = await app.store.workspace_user.fetchNotYetReminds(data);
      sclazyData.cursor = reminds.slice(-1)[0];
      return reminds;
    };

    this.getSectionedReminds = () => {
      let sections = _.groupBy(this.sclazy.items, item => {
        let d = dayjs(item.data.created_at);
        return `${d.format('YYYY/MM/DD(ddd)')}`;
      });

      return sections;
    };

    this.selectTab = (e) => {
      this.current = e.item.tab.id;
      this.update();
      this.sclazy.reset().load();
    };

    this.reload = () => {
      this.lastItem = null;
      this.sclazy.reset().load();
    };

    this.toggleMeMentionChecked = (e) => {
      this.update({ containMeMentionChecked: e.currentTarget.checked });
    };

    this.toggleManualRemindChecked = (e) => {
      this.update({ typeManualChecked: e.currentTarget.checked });
    };

    this.getFilterItems = (items) => {

      if (this.containMeMentionChecked) {
        items = items.filter(item => this.existsScreenName(item));
      }

      if (this.typeManualChecked) {
        items = items.filter(item => item.data.type === 'manual');
      }

      let project_tag = this.getProjectQuery();
      if (project_tag) {
        items = items.filter(item => item.relation.project.id === project_tag);
      }
      return items;
    };

    this.existsScreenName = (item) => {
      let { screen_name } = app.store.currentUser.data;
      return item.relation.message.data.mentions.some(mention => `@${screen_name}` === mention);
    };

    this.clickMeMentionCheckbox = () => {
      this.refs.meMentionCheckbox.click();
    };

    this.toggleDoneCurrentRemind = () => {
      const current = this.currentRemind;
      if (current) {
        if (current.data.done) {
          this.restoreCurrentRemind();
        }
        else {
          this.doneCurrentRemind();
        }
      }
    };

    this.doneCurrentRemind = async () => {
      const current = this.currentRemind;
      if (current) {
        try {
          if (!current.relation.message.hasMyReaction()) {

            current.addReaction('Eyes');
            current.look();
          }
          await current.done();
          await current.refresh();
          this.update();
        }
        catch (e) {
          console.error(e);
        }
      }
    };

    this.restoreCurrentRemind = async () => {
      const current = this.currentRemind;
      if (current) {
        try {
          await current.restore();
          await current.refresh();
          this.update();
        }
        catch (e) {
          console.error(e);
        }
      }
    };

    this.onMouseEnterRemind = (e) => {
      this.currentRemind = e.item.item;
    };

    this.onMouseLeaveRemind = (e) => {
      this.currentRemind = null;
    };
});